import React from 'react';
import { motion } from 'framer-motion';
import { researchPriorities } from '../../data/research';
import { fadeUp } from '../../utils/motion';
export function ResearchPriorities() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-1943" data-mp="2k7uji07q7icd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1944" data-mp="2k95mvyx9eo2y">
        <motion.h2 {...fadeUp} className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight mb-14" data-id="element-1945" data-mp="2p5m6qgxfega8">
          Research priorities
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 border-t border-line" data-id="element-1946" data-mp="3gwk0lobj46xa">
          {researchPriorities.map(priority => <motion.article key={priority.title} {...fadeUp} className="border-b border-line py-10" data-id="element-1947" data-mp="32zwsqqi1fwcl">
              <h3 className="font-heading font-bold text-2xl text-ink-dark mb-4" data-id="element-1948" data-mp="37yzxe9u3w0k1">{priority.title}</h3>
              <div className="space-y-4" data-id="element-1949" data-mp="1rkq6p92e5zq1">
                {priority.paragraphs.map(paragraph => <p key={paragraph} className="text-lg text-ink-muted leading-relaxed" data-id="element-1950" data-mp="1wfdpcraprzwp">
                    {paragraph}
                  </p>)}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}